// Generated by purs version 0.15.15
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Data_Array_NonEmpty from "../Data.Array.NonEmpty/index.js";
import * as Data_Array_NonEmpty_Internal from "../Data.Array.NonEmpty.Internal/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_EuclideanRing from "../Data.EuclideanRing/index.js";
import * as Data_Foldable from "../Data.Foldable/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_Int from "../Data.Int/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Number from "../Data.Number/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Semiring from "../Data.Semiring/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Effect_Aff from "../Effect.Aff/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Test_Spec from "../Test.Spec/index.js";
import * as Test_Spec_Assertions from "../Test.Spec.Assertions/index.js";
var foldl = /* #__PURE__ */ Data_Foldable.foldl(Data_Array_NonEmpty_Internal.foldableNonEmptyArray);
var div1 = /* #__PURE__ */ Data_EuclideanRing.div(Data_EuclideanRing.euclideanRingInt);
var identity = /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn);
var sort = /* #__PURE__ */ Data_Array_NonEmpty.sort(Data_Ord.ordNumber);
var sum = /* #__PURE__ */ Data_Foldable.sum(Data_Array_NonEmpty_Internal.foldableNonEmptyArray)(Data_Semiring.semiringNumber);
var map = /* #__PURE__ */ Data_Functor.map(Data_Array_NonEmpty_Internal.functorNonEmptyArray);
var describe = /* #__PURE__ */ Test_Spec.describe(Data_Identity.monadIdentity);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var discard1 = /* #__PURE__ */ discard(/* #__PURE__ */ Test_Spec.bindSpecT(Data_Identity.bindIdentity));
var it = /* #__PURE__ */ Test_Spec.it(Data_Identity.monadIdentity)(Test_Spec.exampleMUnit);
var discard2 = /* #__PURE__ */ discard(Effect_Aff.bindAff);
var shouldEqual = /* #__PURE__ */ Test_Spec_Assertions.shouldEqual(Effect_Aff.monadThrowAff)(Data_Show.showNumber)(Data_Eq.eqNumber);
var updateRfc3550VarianceEstimate = function (newTransit) {
    return function (acc) {
        return {
            transit: newTransit,
            jitter: (function () {
                var d = newTransit - acc.transit;
                var abs_d = Data_Number.abs(d);
                return acc.jitter + (1.0 / 16.0) * (abs_d - acc.jitter);
            })()
        };
    };
};
var rfc3550VarianceEstimate = function (vals) {
    var initial = {
        transit: Data_Array_NonEmpty.head(vals),
        jitter: 0.0
    };
    var $$final = foldl(Data_Function.flip(updateRfc3550VarianceEstimate))(initial)(vals);
    return $$final.jitter;
};
var getMiddleVal = function (vals) {
    var idx = div1(Data_Array_NonEmpty.length(vals))(2);
    return Data_Maybe["maybe$prime"](function (v) {
        return Partial_Unsafe.unsafeCrashWith("Faulty implementation of `getMiddleVal`");
    })(identity)(Data_Array_NonEmpty.index(vals)(idx));
};
var median = function (vals) {
    return getMiddleVal(sort(vals));
};
var average = function (vals) {
    return sum(vals) / Data_Int.toNumber(Data_Array_NonEmpty.length(vals));
};
var variance = function (vals) {
    var count = Data_Int.toNumber(Data_Array_NonEmpty.length(vals));
    var avg = average(vals);
    return (function (s) {
        return Data_Number.sqrt(s / count);
    })(sum(map(function (val) {
        return Data_Number.pow(val - avg)(2.0);
    })(vals)));
};
var spec = /* #__PURE__ */ describe("Fusion.Statistics")(/* #__PURE__ */ discard1(/* #__PURE__ */ describe("average")(/* #__PURE__ */ it("works for sample inputs")(/* #__PURE__ */ discard2(/* #__PURE__ */ shouldEqual(/* #__PURE__ */ average(/* #__PURE__ */ Data_Array_NonEmpty["cons$prime"](1.0)([ 3.0, 1.0, 3.0 ])))(2.0))(function () {
    return discard2(shouldEqual(average(Data_Array_NonEmpty["cons$prime"](1.0)([  ])))(1.0))(function () {
        return shouldEqual(average(Data_Array_NonEmpty["cons$prime"](3.0)([ 5.0, 8.0, 1.0 ])))(4.25);
    });
}))))(function () {
    return discard1(describe("variance")(discard1(it("is zero for monotonous sequences")(shouldEqual(variance(Data_Array_NonEmpty["cons$prime"](42.0)([ 42.0, 42.0, 42.0 ])))(0.0)))(function () {
        return it("works for sample inputs")(shouldEqual(variance(Data_Array_NonEmpty["cons$prime"](3.0)([ 5.0, 8.0, 1.0 ])))(2.5860201081971503));
    })))(function () {
        return discard1(describe("median")(discard1(it("works for inputs of any length")(discard2(shouldEqual(median(Data_Array_NonEmpty["cons$prime"](42.0)([  ])))(42.0))(function () {
            return discard2(shouldEqual(median(Data_Array_NonEmpty["cons$prime"](0.0)([ 1.0 ])))(1.0))(function () {
                return discard2(shouldEqual(median(Data_Array_NonEmpty["cons$prime"](0.0)([ 1.0, 2.0 ])))(1.0))(function () {
                    return shouldEqual(median(Data_Array_NonEmpty["cons$prime"](0.0)([ 1.0, 2.0, 3.0 ])))(2.0);
                });
            });
        })))(function () {
            return it("works for unsorted inputs")(shouldEqual(median(Data_Array_NonEmpty["cons$prime"](0.0)([ 2.0, 1.0 ])))(1.0));
        })))(function () {
            return describe("rfc3550VarianceEstimate")(discard1(it("is zero for monotonous sequences")(discard2(shouldEqual(rfc3550VarianceEstimate(Data_Array_NonEmpty["cons$prime"](42.0)([  ])))(0.0))(function () {
                return shouldEqual(rfc3550VarianceEstimate(Data_Array_NonEmpty["cons$prime"](42.0)([ 42.0, 42.0, 42.0 ])))(0.0);
            })))(function () {
                return it("works for sample inputs")(shouldEqual(rfc3550VarianceEstimate(Data_Array_NonEmpty["cons$prime"](3.0)([ 5.0, 8.0, 1.0 ])))(0.72314453125));
            }));
        });
    });
}));
export {
    average,
    median,
    rfc3550VarianceEstimate,
    spec,
    variance
};
//# sourceMappingURL=index.js.map
